import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Grid from "@mui/material/Grid";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import MDBox from "components/MDBox";
import { Box, Button, TextField } from "@mui/material";
import MDTypography from "components/MDTypography";

import { Edit, Save } from "@mui/icons-material";

import { useEditProgramme } from "hooks/settingsHooks/useEditProgramme";
import { toast } from "sonner";

const EditProgrammePopup = ({ programme }) => {
  const [open, setOpen] = useState(false);
  const [programmename, setProgrammename] = useState("");
  const [programmecode, setProgrammecode] = useState("");
  const [programmeduration, setProgrammeduration] = useState("");
  const { editprogramme, error, isLoading, success, setError, setSuccess } =
    useEditProgramme();

  useEffect(() => {
    if (programme) {
      setProgrammename(programme.programmename);
      setProgrammecode(programme.programmecode);
      setProgrammeduration(programme.programmeduration);
    }
  }, [programme]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // console.log(programme.id, programmename, programmecode, programmeduration);
    await editprogramme(
      programme.id,
      programmename,
      programmecode,
      programmeduration
    );
    handleClose();
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);

    // Clear error on close
    setError(null);
    setSuccess(null);
  };

  useEffect(() => {
    if (error) {
      toast.error("Error", { description: error });
    }

    if (success) {
      toast.success("Success", { description: success });
    }
  }, [success, error]);

  return (
    <div>
      <Button onClick={handleClickOpen}>
        <Edit sx={{ cursor: "pointer", fontWeight: "bold" }} color="warning" />
      </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          style: { padding: 20, borderRadius: 10 },
        }}
      >
        <DialogTitle>Edit Programme</DialogTitle>
        <DialogContent>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <TextField
              label="Programme name..."
              name="programmeName"
              value={programmename}
              onChange={(e) => setProgrammename(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Programme code..."
              name="programmeCode"
              value={programmecode}
              onChange={(e) => setProgrammecode(e.target.value)}
              fullWidth
              margin="normal"
            />
            <TextField
              label="Programme duration..."
              name="programmeDuration"
              value={programmeduration}
              onChange={(e) => setProgrammeduration(e.target.value)}
              fullWidth
              margin="normal"
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <MDButton onClick={handleClose}>Cancel</MDButton>
          <MDButton
            onClick={handleSubmit}
            variant="contained"
            color="info"
            disabled={isLoading}
            startIcon={<Save />}
          >
            Save
          </MDButton>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default EditProgrammePopup;
